import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export type LayoutTier = "mobile" | "tablet" | "desktop";

export function useLayoutTier(): LayoutTier {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));
  const isTablet = useMediaQuery(theme.breakpoints.only("sm"));

  if (isMobile) return "mobile";
  if (isTablet) return "tablet";
  return "desktop";
}
